// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cn-header{\n    background-color: white;\n    height: 70px;\n    display: flex;\n    border-bottom:4px solid #003A66;\n}\n\n.cn-headerLogo{\n    display: flex;\n    flex:1 1;\n    align-items: center;\n    margin-left: 40px;\n}\n\n.cn-headerOptions{\n    display: flex;\n    flex:1 1;\n    justify-content: flex-end;\n    align-items: center;\n    margin-right: 5%;\n}", ""]);
// Exports
module.exports = exports;
